import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
//Context Components
import tokenAuth from "./Services/token";
import GastosState from "./Contexts/Gastos/gastosState";
import AuthState from "./Contexts/Autenticacion/authState";

import AlertasState from "./Contexts/Alertas/AlertasState";

//imported components
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//custom components
import Navbar from "./Components/layout/Navbar";
import LandingPage from "./Components/layout/LandingPage";
import Dashboard from "./Components/layout/Dashboard";
import Singin from "./Components/layout/Singin";
import Singup from "./Components/layout/SingUp";
import { Fragment } from "react";
import Alert from "./Components/Utilities/Alert";
function App() {
  const token = localStorage.getItem("token");
  tokenAuth(token);

  return (
    <div className="App">
      <Fragment>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <AlertasState>
          <AuthState>
            <GastosState>
              <Router>
                <Navbar />
                <div className="container">
                  <Alert />
                  <Route exact path="/" component={LandingPage} />
                  <Route exact path="/dashboard" component={Dashboard} />
                  <Route exact path="/singup" component={Singup} />
                  <Route exact path="/singin" component={Singin} />
                </div>
              </Router>
            </GastosState>
          </AuthState>
        </AlertasState>
      </Fragment>
    </div>
  );
}

export default App;
